import { isExternalLink } from './predicates'
import type { Attachment } from './types'
import type { LiquidDocument } from '@app/shared/types/sf-data'

export const generateStorageKey = (
  doc: LiquidDocument | Attachment
): string => {
  return isExternalLink(doc)
    ? `${doc.name}_${doc?.url}`
    : `${doc.name}_${doc?.size}`
}
